(function(){
'use strict';
// ---------------------------------------------------------------------------
// Add-on cart guard (v4 — generic). Graphics kits record their chosen add-ons
// as line-item properties ("Add-On: X = Yes ..."), and each add-on is added to
// the cart as its OWN line item. A customer can delete those separate lines at
// the cart page, which would leave the kit tagged as wanting the add-on but the
// add-on unpaid. This guard detects that mismatch, shows a modal, and blocks
// checkout until the customer re-adds the add-on or knowingly continues without.
//
// Covers: Plastic Kit, Fork Wraps, GUTS Seat Cover, Clear Factory Swingarm,
// Mini Plates. New add-ons can be added to ADDON_DEFS below.
// ---------------------------------------------------------------------------
var PLASTICS_URL = 'https://thedesignlabco.com/pages/plastics';
var acknowledged = false;      // customer chose to continue without the add-on(s)
var dismissedThisView = false; // modal shown+dismissed via backdrop this view
var LOG = function(){ try { console.log.apply(console, ['[dl-guard]'].concat([].slice.call(arguments))); } catch(e){} };

function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

// Each add-on: how to detect it was CHOSEN (property key on the kit) and how to
// detect its LINE ITEM is present (match on the add-on product's title/handle).
var ADDON_DEFS = [
  { id:'plastics', label:'Plastic Kit',
    wantKey:function(k){ return k.indexOf('plastic') >= 0; },
    hasLine:function(t){ return /plastic/.test(t) && !/bolt/.test(t); },
    link: PLASTICS_URL, linkText:'Browse Plastic Kits →' },
  { id:'fork', label:'Fork Wraps',
    wantKey:function(k){ return k.indexOf('fork') >= 0; },
    hasLine:function(t){ return /fork\s*wrap/.test(t); },
    link:'https://thedesignlabco.com/collections/fork-wraps', linkText:'Browse Fork Wraps →' },
  { id:'seat', label:'GUTS Seat Cover',
    wantKey:function(k){ return k.indexOf('seat cover') >= 0; },
    hasLine:function(t){ return /seat\s*cover/.test(t); } },
  { id:'swingarm', label:'Clear Factory Swingarm',
    wantKey:function(k){ return k.indexOf('swingarm') >= 0; },
    hasLine:function(t){ return /swingarm/.test(t); } },
  { id:'miniplates', label:'Mini Plates',
    wantKey:function(k){ return k.indexOf('mini plate') >= 0; },
    hasLine:function(t){ return /mini\s*plate/.test(t); } }
];

function propsToPairs(p){
  var out = [];
  if (!p) return out;
  if (Array.isArray(p)) { for (var i=0;i<p.length;i++){ if (p[i]) out.push([''+p[i][0], ''+p[i][1]]); } }
  else { for (var k in p){ if (Object.prototype.hasOwnProperty.call(p,k)) out.push([''+k, ''+p[k]]); } }
  return out;
}
// An add-on is "wanted" if any line item carries an "Add-On: <thing>" property
// set to a Yes value (or the legacy plastics-type note).
function itemWantsDef(item, def){
  var pairs = propsToPairs(item.properties);
  for (var i=0;i<pairs.length;i++){
    var key = pairs[i][0].toLowerCase();
    var val = (pairs[i][1]||'').toLowerCase();
    if (key.indexOf('add-on') >= 0 && def.wantKey(key) && val.indexOf('yes') === 0) return true;
    if (def.id === 'plastics' && key.indexOf('plastics type') >= 0 && (val.indexOf('added') >= 0 || val.indexOf('new plastic') >= 0)) return true;
  }
  return false;
}
function itemHasDef(item, def){
  var t = ((item.product_title || item.title || '') + ' ' + (item.handle || '')).toLowerCase();
  return def.hasLine(t);
}
function getCart(){
  return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin' }).then(function(r){ return r.json(); });
}
function evaluate(cart){
  if (!cart || !cart.items) return { mismatch:false, missing:[] };
  var missing = [];
  for (var d=0; d<ADDON_DEFS.length; d++){
    var def = ADDON_DEFS[d];
    var wanted=false, has=false;
    for (var i=0;i<cart.items.length;i++){
      if (itemWantsDef(cart.items[i], def)) wanted=true;
      if (itemHasDef(cart.items[i], def)) has=true;
    }
    if (wanted && !has) missing.push(def);
  }
  LOG('items:', cart.items.length, 'missing add-ons:', missing.map(function(m){return m.id;}));
  return { mismatch: missing.length > 0, missing: missing };
}

// Keep each kit line's "Add-On: X = Yes" note in sync with what's actually in
// the cart. If an add-on's own line item was removed, flip that kit's flag to
// "No (removed from cart)" so the order never shows an add-on that wasn't paid for.
var reconciling = false;
function reconcile(cart){
  if (reconciling || !cart || !cart.items || !cart.items.length) return Promise.resolve(false);
  var present = {};
  for (var d=0; d<ADDON_DEFS.length; d++){
    for (var i=0;i<cart.items.length;i++){ if (itemHasDef(cart.items[i], ADDON_DEFS[d])){ present[ADDON_DEFS[d].id]=true; break; } }
  }
  var changes = [];
  for (var c=0;c<cart.items.length;c++){
    var item = cart.items[c];
    var pairs = propsToPairs(item.properties);
    if (!pairs.length) continue;
    var toClear = [];
    for (var dd=0; dd<ADDON_DEFS.length; dd++){
      var def = ADDON_DEFS[dd];
      if (present[def.id]) continue;
      for (var pp=0;pp<pairs.length;pp++){
        var key = pairs[pp][0], lk = key.toLowerCase(), val = (pairs[pp][1]||'').toLowerCase();
        if (lk.indexOf('add-on') >= 0 && def.wantKey(lk) && val.indexOf('yes') === 0) toClear.push(key);
      }
    }
    if (toClear.length){
      var newProps = {};
      for (var q=0;q<pairs.length;q++){ newProps[pairs[q][0]] = pairs[q][1]; }
      for (var r2=0;r2<toClear.length;r2++){ newProps[toClear[r2]] = 'No (removed from cart)'; }
      changes.push({ key: item.key, props: newProps });
    }
  }
  if (!changes.length) return Promise.resolve(false);
  reconciling = true;
  LOG('reconciling', changes.length, 'kit line(s)');
  var chain = Promise.resolve();
  changes.forEach(function(ch){
    chain = chain.then(function(){
      return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin', body: JSON.stringify({ id: ch.key, properties: ch.props }) }).then(function(r){ return r.json(); }).catch(function(){});
    });
  });
  return chain.then(function(){ reconciling = false; return true; }, function(){ reconciling = false; return false; });
}
function onCartPage(){ return location.pathname === '/cart' || /^\/cart(\/|\?|#|$)/.test(location.pathname); }

function checkoutButtons(){
  return Array.prototype.slice.call(document.querySelectorAll(
    'button[name="checkout"], input[name="checkout"], [data-checkout], .cart__checkout, .cart__checkout-button, a[href$="/checkout"], .cart__ctas button, .cart-summary button'
  )).filter(function(b){
    var t = (b.innerText || b.value || '').toLowerCase();
    return b.name === 'checkout' || /checkout/.test((b.getAttribute && (b.getAttribute('href')||'')) || '') || /check\s*out/.test(t);
  });
}
function setCheckoutEnabled(on){
  checkoutButtons().forEach(function(b){
    if (on){ b.removeAttribute('disabled'); b.style.pointerEvents=''; b.style.opacity=''; b.removeAttribute('aria-disabled'); }
    else   { b.setAttribute('disabled','disabled'); b.setAttribute('aria-disabled','true'); b.style.pointerEvents='none'; b.style.opacity='0.45'; }
  });
}

// ---- The modal (fixed overlay appended to <body>) ----
function labelList(missing){
  var names = missing.map(function(m){ return m.label; });
  if (names.length === 1) return names[0];
  if (names.length === 2) return names[0] + ' and ' + names[1];
  return names.slice(0,-1).join(', ') + ', and ' + names[names.length-1];
}
function buildModal(missing){
  var ov = document.getElementById('dlAddonModal');
  if (ov) ov.parentNode.removeChild(ov); // rebuild so message reflects current missing set
  ov = document.createElement('div');
  ov.id = 'dlAddonModal';
  ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,0.6);';
  var many = missing.length > 1;
  var names = labelList(missing);
  var linkDef = null;
  for (var i=0;i<missing.length;i++){ if (missing[i].link){ linkDef = missing[i]; break; } }
  var linkHtml = linkDef
    ? '<a href="' + linkDef.link + '" style="display:block;text-align:center;background:#dc2626;color:#fff;font-weight:800;padding:14px 18px;border-radius:8px;text-decoration:none;font-size:15px;">' + linkDef.linkText + '</a>'
    : '<a href="/cart" style="display:block;text-align:center;background:#dc2626;color:#fff;font-weight:800;padding:14px 18px;border-radius:8px;text-decoration:none;font-size:15px;">Review my cart</a>';
  ov.innerHTML =
    '<div role="dialog" aria-modal="true" style="background:#fff;max-width:480px;width:100%;border-radius:14px;padding:26px 24px;box-shadow:0 24px 70px rgba(0,0,0,0.4);font-family:inherit;color:#1f2937;box-sizing:border-box;">' +
      '<div style="font-size:21px;font-weight:800;color:#b91c1c;margin-bottom:10px;line-height:1.25;">⚠️ Your ' + names + ' ' + (many ? "aren’t" : "isn’t") + ' in the cart</div>' +
      '<p style="margin:0 0 16px;font-size:15px;line-height:1.55;color:#374151;">Your graphics order is set up with <strong>' + names + '</strong>, but ' + (many ? 'those add-ons are' : 'that add-on is') + ' a <strong>separate item</strong> and ' + (many ? "aren’t" : "isn’t") + ' in your cart right now (' + (many ? 'they were' : 'it was') + ' likely removed). Re-add ' + (many ? 'them' : 'it') + ' so you’re not missing part of your order.</p>' +
      linkHtml +
      '<button type="button" id="dlAddonContinue" style="display:block;width:100%;margin-top:10px;background:#f3f4f6;color:#374151;border:1px solid #d1d5db;font-weight:600;padding:12px 18px;border-radius:8px;font-size:13.5px;cursor:pointer;">No thanks — continue without ' + (many ? 'these add-ons' : names) + '</button>' +
      '<p style="margin:12px 0 0;font-size:11.5px;color:#9ca3af;text-align:center;">Continuing means ' + (many ? 'these add-ons' : 'this add-on') + ' won’t be included or shipped.</p>' +
    '</div>';
  document.body.appendChild(ov);
  ov.querySelector('#dlAddonContinue').addEventListener('click', function(){
    acknowledged = true;
    closeModal();
    setCheckoutEnabled(true);
  });
  ov.addEventListener('click', function(e){ if (e.target === ov){ dismissedThisView = true; closeModal(); } });
  return ov;
}
function openModal(missing){
  if (acknowledged || dismissedThisView) return;
  buildModal(missing).style.display = 'flex';
}
function closeModal(){
  var ov = document.getElementById('dlAddonModal');
  if (ov) ov.style.display = 'none';
}

function apply(){
  return getCart().then(function(cart){
    closeModal();
    setCheckoutEnabled(true);
    return reconcile(cart);
  }).catch(function(e){ LOG('cart fetch error', e); return false; });
}

function pollApply(times){
  var n = 0;
  (function tick(){ apply(); if (++n < times) setTimeout(tick, 500); })();
}

function observeCart(){
  var t=null;
  function schedule(){ clearTimeout(t); t = setTimeout(apply, 350); }
  new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true });
  ['cart:updated','cart:refresh','cart:change','cart:build','cart:item-removed','ajaxCart.afterCartLoad','CartUpdate'].forEach(function(ev){
    document.addEventListener(ev, schedule); window.addEventListener(ev, schedule);
  });
  try { if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && window.PUB_SUB_EVENTS.cartUpdate.subscribe) window.PUB_SUB_EVENTS.cartUpdate.subscribe(apply); } catch(e){}
}

// Backstop: catch checkout clicks anywhere. If mismatch + not acknowledged,
// stop and show the modal (or route to /cart if not on the cart page).
document.addEventListener('click', function(e){
  var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], [data-checkout]');
  if (!btn) return;
  if (btn.getAttribute && btn.getAttribute('data-dl-done') === '1') return;
  e.preventDefault(); e.stopImmediatePropagation();
  getCart().then(function(cart){ return reconcile(cart); }).then(function(){
    if (btn.setAttribute) btn.setAttribute('data-dl-done','1');
    var form = btn.closest && btn.closest('form');
    if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn);
    else if (form) form.submit();
    else if (btn.tagName === 'A' && btn.getAttribute('href')) window.location.href = btn.getAttribute('href');
    else window.location.href = '/checkout';
  }).catch(function(){ window.location.href = '/checkout'; });
}, true);

LOG('loaded v4-addon-guard; cartPage=', onCartPage());
ready(function(){
  if (onCartPage()) pollApply(8);
  observeCart();
});
})();

// ---------------------------------------------------------------------------
// Acknowledgment gate (v1). Some product pages have a REQUIRED "this is a
// graphics kit only / a real bike is NOT included" checkbox that the theme
// does NOT actually enforce (the field is form-associated but rendered outside
// the <form>, so native validation skips it). This module hard-blocks add-to-
// cart until that checkbox is ticked, and visually disables the button.
// Only activates on pages that actually contain the acknowledgment checkbox.
// ---------------------------------------------------------------------------
(function(){
  'use strict';
  var ACK_RE = /real bike is not included|graphics kit only/i;
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function findAck(){
    var boxes = [].slice.call(document.querySelectorAll('input[type=checkbox]'));
    for (var i=0;i<boxes.length;i++){
      var c = boxes[i];
      var lbl = ((c.closest('label') || c.parentElement || {}).innerText || '');
      var nm  = (c.getAttribute('name') || '');
      if (ACK_RE.test(lbl) || ACK_RE.test(nm)) return c;
    }
    return null;
  }
  function isMainAtc(btn){
    if (!btn) return false;
    var t = (btn.innerText || btn.value || '').trim().toLowerCase();
    return t === 'add to cart' || t === 'add to bag';
  }
  function mainAtcButtons(){
    return [].slice.call(document.querySelectorAll('button, input[type=submit]')).filter(isMainAtc);
  }
  function applyDisabled(){
    var ack = findAck(); if (!ack) return;
    var wantDisabled = !ack.checked;
    mainAtcButtons().forEach(function(b){
      var gated = b.getAttribute('data-dl-gated') === '1';
      if (wantDisabled && !gated){
        b.setAttribute('disabled','disabled'); b.setAttribute('aria-disabled','true');
        b.style.opacity = '0.45'; b.style.pointerEvents = 'none'; b.setAttribute('data-dl-gated','1');
      } else if (!wantDisabled && gated){
        b.removeAttribute('disabled'); b.removeAttribute('aria-disabled');
        b.style.opacity = ''; b.style.pointerEvents = ''; b.removeAttribute('data-dl-gated');
      }
    });
  }
  function flash(ack){
    var wrap = ack.closest('label') || ack.closest('.line-item-property, .block, .product-form__input') || ack.parentElement;
    if (!wrap) return;
    try { wrap.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(e){ wrap.scrollIntoView(); }
    wrap.style.outline = '2px solid #dc2626'; wrap.style.outlineOffset = '3px';
    setTimeout(function(){ wrap.style.outline = ''; wrap.style.outlineOffset = ''; }, 1800);
  }
  ready(function(){
    if (!findAck()) return; // no acknowledgment on this page — do nothing
    applyDisabled();
    // Hard block: capture add-to-cart clicks before the theme handles them.
    document.addEventListener('click', function(e){
      var ack = findAck(); if (!ack || ack.checked) return;
      var btn = e.target.closest && e.target.closest('button, input[type=submit], a');
      if (!isMainAtc(btn)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      flash(ack);
    }, true);
    // Hard block: capture any submit of the add-to-cart form.
    document.addEventListener('submit', function(e){
      var ack = findAck(); if (!ack || ack.checked) return;
      var f = e.target;
      if (!f || !(f.getAttribute && (f.getAttribute('action')||'').indexOf('/cart/add') >= 0)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      flash(ack);
    }, true);
    // Keep button state synced with the checkbox and across theme re-renders.
    var ack0 = findAck();
    if (ack0) ack0.addEventListener('change', applyDisabled);
    document.addEventListener('change', function(e){ if (e.target && e.target.type === 'checkbox' && ACK_RE.test((e.target.getAttribute('name')||''))) applyDisabled(); });
    var t = null;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(applyDisabled, 250); })
      .observe(document.querySelector('#main, main') || document.body, { childList:true, subtree:true });
  });
})();
